<template>
    <csp-base-file-upload
        v-bind="$attrs"
        :additional-params="additionalParams"
        :on-transform="handleFileTransform"
        :show-message="false"
        title=""
        :upload-url="uploadUrl"
        :wrapper-classes="wrapperClasses"
        @upload-complete="handleUploadComplete">
        <span v-bind="iconAttributes" class="upload-icon">
            <b-img alt="File Upload Image" height="100" :src="imageFileUpload" width="100"/>
        </span>
        <p class="text-uppercase font-weight-bold upload-label">
            {{ uploadLabel }}
        </p>
    </csp-base-file-upload>
</template>

<script>
    import imageFileUpload from '@csp-app/images/file/icon-floatingbutton-camera.svg';
    import Container from '@services/Container';
    import DokaFactory from '../../lib/vendor/doka/DokaFactory';
    import '@scss/components/record-create-image-file-upload.scss';

    export default {
        props: {
            uploadFileCategoryId: {
                type: Number,
                required: true,
            },
            uploadLabel: {
                type: String,
                default: '',
            },
            uploadSessionId: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                imageFileUpload,
                uploadUrl: '/api/records/files',
                fileCount: null,
                wrapperClasses: [
                    'text-center',
                ],
            }
        },
        computed: {
            additionalParams() {
                return {
                    fileCategoryId: this.uploadFileCategoryId,
                    uploadSessionId: this.uploadSessionId,
                };
            },
            iconAttributes() {
                let attributes = {};

                if (this.fileCount !== null) {
                    attributes['data-file-count'] = this.fileCount;
                }

                return attributes;
            },
        },
        mounted() {
            const container = Container.getInstance();
            this.recordRepository = container.getRecordRepository();
            this.flashMessenger = container.getFlashMessenger();

            this.fetchFileCount();
        },
        methods: {
            handleFileTransform(file, done) {
                let transformMimeTypes = this.$attrs['transform-mime-types'] || ''
                transformMimeTypes = transformMimeTypes.split(',').map(a => a.trim())
                if (!transformMimeTypes.includes(file.type)) {
                    done(file)
                    return
                }

                var doka = DokaFactory.create(this.$root);

                doka.edit(file).then(
                    (output) => {
                        if (!output) {
                            this.$refs.fileUpload.reset();
                            return;
                        }
                        done(output.file);
                    },
                    () => this.$refs.fileUpload.reset()
                );
            },
            handleUploadComplete(data, statistics) {
                let translationKey = 'record image upload success';

                if (statistics.numberOfAddedFiles > 1) {
                    translationKey = translationKey + ' multiple';
                }

                if (statistics.numberOfSuccessfullyUploadedFiles === statistics.numberOfAddedFiles) {
                    this.flashMessenger.addSuccess(this.$t(translationKey, statistics));
                } else {
                    this.flashMessenger.addWarning(this.$t(translationKey, statistics));
                }

                this.fetchFileCount();
            },
            fetchFileCount() {
                this.recordRepository.getSessionFileCount(this.uploadSessionId, this.uploadFileCategoryId).then(
                    (response) => {
                        const attributes = response.data.attributes;
                        this.fileCount = attributes.fileCount;
                    }
                );
            },
        },
    }
</script>
